import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import AttorneyHubAPIService from "_shared/_api/attorney-hub-api-service";
import { isRejectedWithValue } from "@reduxjs/toolkit";
import type { MiddlewareAPI, Middleware } from "@reduxjs/toolkit";
import Session from "users/__session/session";

export const api = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: AttorneyHubAPIService.apiBaseUrl,
    prepareHeaders: (headers) => {
      const authToken = Session.loadFromStorage(() => {}).authToken?.value;
      if (authToken) {
        headers.set("Authorization", `Bearer ${authToken}`);
      }
      return headers;
    },
    fetchFn: async (input, init) => {
      if (input instanceof Request) {
        if (input.method.toUpperCase() === "PATCH") {
          input.headers.set("Content-Type", "application/json-patch+json");
        }
      }

      if (init?.method?.toUpperCase() === "PATCH") {
        if (!init.headers)
          init.headers = {
            "Content-Type": "application/json-patch+json",
          };
        if (init.headers instanceof Headers) {
          init.headers.set("Content-Type", "application/json-patch+json");
        }
      }
      return fetch(input, init);
    },
  }),
  tagTypes: [
    "EntityMember",
    "Individual",
    "NetworkedGroup",
    "NetworkInvitation",
    "Proposal",
    "UserCoworker",
    "UserInformation",
    "UserNetworkConnection",
  ],
  endpoints: () => ({}),
});

export const rtkQueryErrorLogger: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    console.error("We got a rejected action!", api, action);
  }
  return next(action);
};
